<template>
  <div class="w-full flex justify-center pt-8">
    <div class="flex w-full lg:w-3/4 bg-white px-2 py-3 mt-3 gap-2 mb-2 shadow-my">
      <div class="flex justify-center items-center">
        <div
          class="h-20 w-20 rounded-full flex items-center justify-center overflow-hidden"
        >
          <img v-if="user.photo" :src="user.photo" />
          <font-awesome-icon
            v-else
            icon="fa-solid fa-user"
            size="2x"
            class="text-gray-500"
          />
        </div>
      </div>
      <div class="flex flex-col leading-loose" v-if="user">
        <h1 class="text-2xl mb-2">{{ c.welcomeback }}</h1>
        <h1 class="font-bold mb-3 text-2xl">{{ user.name }}</h1>
        <p class="text-m">{{ formatDate(Date.now()) }}</p>
      </div>
    </div>
  </div>

  <!--link to post-->
  <div class="fixed bottom-0 right-0 h-20 w-20 p-4 z-20">
    <router-link
      to="/posting"
      class="w-full h-full rounded-full bg-yellow-700 flex justify-center items-center text-2xl text-white"
    >
      <font-awesome-icon icon="fa-solid fa-paper-plane" />
    </router-link>
  </div>
  <!--end link to post -->

  <div
    v-for="post in allPosts"
    :key="post.createdOn"
    class="flex justify-center w-full"
  >
    <div class=" w-full lg:w-3/4 mb-2 shadow-my px-2 py-1">
    <div
      class="relative flex justify-between items-center w-full border-b border-gray-200"
    >
      <div
        class="absolute w-36 top-0 right-0 bg-white rounded-l mt-14 mr-3 flex flex-col transition-all duration-500"
        :class="
          showPostOptions(post.id)
            ? 'p-3 gap-2 border border-yellow-700'
            : 'h-0 overflow-hidden'
        "
      >
        <router-link
          :to="`/edit/post/id=${post.id}`"
          v-if="user.id == post.userId && post.type != 'guess'"
        >
          <font-awesome-icon icon="fa-solid fa-pencil" class="mr-2" />{{c.edit}}
        </router-link>
        <router-link
          :to="`/delete/post/id=${post.id}`"
          v-if="user.id == post.userId"
        >
          <font-awesome-icon icon="fa-solid fa-trash" class="mr-2" />{{c._delete}}
        </router-link>
        <router-link
          v-if="user.id != post.userId"
          :to="`/report/post/id=${post.id}`"
        >
          <font-awesome-icon
            icon="fa-solid fa-exclamation-circle"
            class="mr-2"
          />{{c.report}}
        </router-link>
      </div>
      <router-link
        :to="`/user/profile/id=${post.userId}`"
        class="flex justify-center items-center"
      >
        <div
          class="h-14 w-14 rounded-full flex items-center justify-center overflow-hidden"
        >
          <img v-if="post.userPhoto" :src="post.userPhoto" />
          <font-awesome-icon
            v-else
            icon="fa-solid fa-user"
            size="4x"
            class="text-gray-500"
          />
        </div>
      </router-link>
      <router-link
        :to="`/user/profile/id=${post.userId}`"
        class="w-3/4 flex flex-wrap py-4 pl-2"
      >
        <h5 class="font-black tracking-wider text-2xl mb-2 w-full">
          {{ post.userName }}
        </h5>
        <p class="text-s">{{ formatDate(post.createdOn) }}</p>
      </router-link>
      <font-awesome-icon
        v-if="post.type == 'guess' && post.userId != user.id"
        icon="fa-solid fa-check-circle"
        class="text-2xl"
        :class="
          post.content.answered.includes(user.id)
            ? 'text-green-600'
            : 'text-gray-600'
        "
      />
      <font-awesome-icon
        v-if="postOptionsId == post.id"
        @click="onPostOptions(post.id)"
        icon="fa-solid fa-times"
        class="ml-3 text-2xl w-6 text-gray-600"
      />
      <font-awesome-icon
        v-else
        @click="onPostOptions(post.id)"
        icon="fa-solid fa-chevron-down"
        class="ml-3 text-2xl text-gray-600"
      />
    </div>
    <div
      v-if="post.type == 'status'"
      class="flex w-full p-3 text-xl leading-loose text-justify whitespace-pre-wrap break-all"
    >
      {{ post.content.status }}
    </div>
    <div
      v-else
      class="flex w-full p-3 text-xl leading-loose text-justify whitespace-pre-wrap break-all"
    >
      {{ post.content.hint }}
    </div>
    <div v-if="post.content.image" class="w-full flex p-1 justify-center">
      <img :src="post.content.image" class="w-full" alt="" />
    </div>
    <router-link
      :to="`post/id=${post.id}`"
      v-if="post.type == 'guess'"
      class="w-full px-2 flex flex-col justify-center items-center mb-2"
    >
      <div class="flex justify-between items-center mt-6 gap-2">
        <div
          v-for="(letter,i) in answer(post.content.answer)"
          :key="i"
          class="flex justify-center items-center text-3xl w-12 h-12 ring-2 ring-gray-400 rounded-lg" :class="post.content.answered.includes(user.id) ? 'ring-yellow-700' : 'ring-gray-600'"
        >
          {{post.content.answered.includes(user.id)
              ? letter
              : ''}}
        </div>
      </div>
    </router-link>
    <div
      class="flex w-full justify-between text-center items-center h-10 border-t py-2"
    >
      <button
        class="flex items-center w-full justify-center focus:outline-none bg-gray-100 rounded-full py-1 mr-0.5"
        @click="likes(post.id, post.userId)"
      >
        <h5 v-if="post.likes.length > 0">{{ post.likes.length }}</h5>
        <font-awesome-icon
          :icon="
            post.likes.includes(user.id)
              ? 'fa-solid fa-heart'
              : 'fa-regular fa-heart'
          "
          class="mx-2 text-xl"
          :class="post.likes.length > 0 ? 'text-pink-700' : 'text-gray-600'"
        />{{ c.like }}
      </button>
      <router-link
        :to="`post/${post.userId}/comments/id=${post.id}`"
        class="flex items-center w-full justify-center bg-gray-100 rounded-full py-1 ml-0.5"
      >
        <h5 v-if="post.comments > 0">{{ post.comments }}</h5>
        <font-awesome-icon
          icon="fa-regular fa-comment"
          class="text-xl mx-2"
        />{{ c.comments }}
      </router-link>
    </div>
  </div>
   </div>
  <div
    v-if="!disableNext"
    class="after:h-px my-8 flex items-center before:h-px before:flex-1 before:bg-gray-300 before:content-[''] after:h-px after:flex-1 after:bg-gray-300 after:content-['']"
  >
    <button
      type="button"
      class="flex items-center rounded-full border border-gray-300 bg-secondary-50 px-3 py-2 text-center text-sm font-medium text-gray-900 hover:bg-gray-100"
      @click="nextPage"
      :disabled="disableNext"
    >
      <font-awesome-icon
        icon="fa-solid fa-chevron-down"
        class="text-sm mb-1 mr-1"
      />
      {{c.nextPage}}
    </button>
  </div>
  <div
    v-else
    class="after:h-px my-8 flex items-center before:h-px before:flex-1 before:bg-gray-300 before:content-[''] after:h-px after:flex-1 after:bg-gray-300 after:content-['']"
  >
    <button
      type="button"
      class="flex items-center rounded-full border border-gray-300 bg-secondary-50 px-3 py-2 text-center text-sm font-medium text-gray-900 hover:bg-gray-100"
    
      :disabled="disableNext"
    >{{c.lastPage}}
    </button>
  </div>
 
</template>

<script>
import graphemeSplitter from "../services/grapheme-splitter";
import constants from "../services/constants";
import tanggal from "../services/tanggalBali";
import { ref, computed } from "vue";
import { useStore } from "vuex";
export default {
  name: "HomeView",
  components: {},
  setup() {
    const store = useStore();
    const c = ref(constants);
    const postOptionsId = ref("");
    const onPostOptions = (postId) => {
      if (postOptionsId.value == postId) {
        postOptionsId.value = "";
      } else {
        postOptionsId.value = postId;
      }
    };
    const showPostOptions = (postId) => {
      if (postOptionsId.value == postId) {
        return true;
      }
      return false;
    };
    const allPosts = computed(() => {
      return store.state.posts;
    });
    const user = computed(() => {
      return store.state.userProfile;
    });
    const disableNext = computed(() => {
      if (allPosts.value.length < store.state.limit) {
        return true;
      } else {
        return false;
      }
    });

    const likes = async (postId, userId) => {
      const postNotif = {
        postId: postId,
        userId: userId,
        type: "like",
      };
      await store.dispatch("likePost", postNotif);
    };
    const formatDate = (time) => {
      return tanggal(time);
    };
    const answer = (string) => {
      return graphemeSplitter.splitGraphemes(string);
    };
    const nextPage = () => {
      store.state.limit += 5;
      store.dispatch("fetchAllPosts");
    };

    return {
      allPosts,
      c,
      user,
      disableNext,
      likes,
      formatDate,
      answer,
      nextPage,
      postOptionsId,
      showPostOptions,
      onPostOptions,
    };
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
